const StateHtml = `
<div class="sm:px-4 sm:pt-16 md:px-16 md:pt-0">
  <section id="California">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      California
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Pasadena </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2252"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
         <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2252"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Connecticut">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Connecticut
    </h3>
       <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5">Bluepoint Westport</span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1263"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Branford </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4970"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1501"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Orange </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
      <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5653"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2817"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Florida">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Florida
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Bonita Springs </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/773"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/773"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Brandon </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5077"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5077"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Clearwater </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5417"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5417"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Crystal River </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5419"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5419"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Deerfield Beach </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/596"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/596"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
     <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Dunnellon </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5785"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5419"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Fruitland Park </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5420"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5420"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Hallandale Beach </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/790"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/790"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Jacksonville </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6057"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Kendall </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2040"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2040"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary New Port Richey</span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="/"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5417"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Ocala on College Rd </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5424"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5424"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5">RISE Dispensary Orlando on Good Homes Rd</span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6056"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Oviedo </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/834"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/834"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Pinellas Park </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/730"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/730"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Port Orange </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5270"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5270"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Sun City </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5550"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
         <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5077"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Tallahassee on Mahan </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5960"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5960"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
        <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Tallahassee on Tennessee </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5964"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5960"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Tampa </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5428"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5428"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Wesley Chapel </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5788"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
         <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5428"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary West Palm Beach </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1253"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1253"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Illinois">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Illinois
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Canton </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1343"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/836"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Charleston </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2525"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Effingham </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1497"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/252"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5">RISE Dispensary Joliet on Colorado </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1340"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Joliet on Rock Creek </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1344"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/254"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Lake in the Hills </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2901"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Mundelein </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1342"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/253"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Mundelein Lounge </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://risecannabis.com/dispensaries/illinois/mundelein/1342/recreational-menu/"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Shop Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.opentable.com/r/rise-mundelein-lounge-mundelein"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Reservations and Events</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Naperville </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2265"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/255"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Niles </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1812"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Quincy </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1338"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Maryland">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Maryland
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Bethesda </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5476"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/615"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Hagerstown </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5477"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4061"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Joppa </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5478"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/616"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Silver Spring </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5486"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/461"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Massachusetts">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Massachusetts
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Chelsea </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4636"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6517 "
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Dracut </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4637"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Maynard </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4638"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> Affinity Dispensary West Springfield </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.affinityne.com/menu-west-springfield/"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Minnesota">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Minnesota
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Baxter </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6466"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5205"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Brooklyn Park </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6459"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6121"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Eagan </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6455"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4635"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Mankato </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6454"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4631"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary New Hope </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6460"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff]"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5268"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary St. Cloud </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6458"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4633"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary St. Paul </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6456"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4634"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Willmar </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6457"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4632"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Nevada">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Nevada
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Carson City on US HWY 50 </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6128"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Carson City </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1475"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1475"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Henderson </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/887"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/887"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
    <div class="items-center">
      <div class="sub_menu_more_details_btn">
        <div
          class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
        >
          <span class="w-4/5"> RISE Dispensary Henderson on Boulder</span>
        </div>
      </div>
    </div>
    <div class="flex justify-between gap-x-3">
      <div class="single-menu-button list_dispensaries_menu_btn w-full">
        <a
          href="https://www.iheartjane.com/embed/stores/6211"
          class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
          >Pickup Menu</a
        >
      </div>
    </div>
  </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5">
              RISE on the Strip Dispensary Las Vegas
            </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/888"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/888"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Las Vegas on Craig Rd </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5429"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/886"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5">RISE Dispensary Las Vegas on Nellis</span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5267"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5267"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5">
              RISE Dispensary Las Vegas on South Durango
            </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1885"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/886"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"
              >RISE Dispensary Las Vegas on South Rainbow
            </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1718"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/886"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5">
              RISE Dispensary Las Vegas on West Tropicana
            </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/886"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/886"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Reno </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3417"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3417"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Spanish Springs </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1474"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3417"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="New_Jersey">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      New Jersey
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Bloomfield </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4439"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3422"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Paramus </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2446"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Paterson </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4440"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1317"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="New_York">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      New York
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary East Syracuse </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6115"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5907"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Halfmoon Clifton Park </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6086"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1180"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Henrietta</span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5800"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1182"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Long Beach </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5624"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
        <a
          href="https://www.iheartjane.com/embed/stores/5624"
          class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
          >Delivery Menu</a
        >
      </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Manhattan NYC </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1181"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Ohio">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Ohio
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Cleveland </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6015"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Non-Medical Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/874"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Cleveland on Pearl Rd </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6013"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Non-Medical Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1531"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Lakewood on Madison </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6014"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Non-Medical Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1341"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Lorain </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6012"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Non-Medical Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/756"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Toledo </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6011"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Non-Medical Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/725"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
    <div class="items-center">
      <div class="sub_menu_more_details_btn">
        <div
          class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
        >
          <span class="w-4/5"> RISE Dispensary Whitehall </span>
        </div>
      </div>
    </div>
    <div class="flex justify-between gap-x-3">
      <div class="single-menu-button list_dispensaries_menu_btn w-full">
        <a
          href="https://www.iheartjane.com/embed/stores/6295"
          class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
          >Non-Medical Menu</a
        >
      </div>
      <div class="single-menu-button list_dispensaries_menu_btn w-full">
        <a
          href="https://www.iheartjane.com/embed/stores/6292"
          class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
          >Medical Menu</a
        >
      </div>
    </div>
  </div>
  </section>
  <section id="Pennsylvania">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Pennsylvania
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Carlisle </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1547"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Chambersburg </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1867"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Cranberry </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1575"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Duncansville </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1961"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Erie on Lake </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/392"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Erie on Peach </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2607"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Grove City </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5202"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff]"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Hermitage </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1551"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary King of Prussia </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1552"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Latrobe </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1549"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Lebanon </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/6520"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Meadville </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2863"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Mechanicsburg </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1550"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Monroeville </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/2266"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary New Castle </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1545"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Philadelphia </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5383"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Steelton </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1544"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Warminster </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3404"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary York </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/1548"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Rhode_Island">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Rhode Island
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Warwick </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4939"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Recreational Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4658"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Medical Menu</a
          >
        </div>
      </div>
    </div>
  </section>
  <section id="Virginia">
    <h3
      class="mb-6 pl-1.5 text-[24px] font-[800] uppercase leading-5 text-primary-100 underline"
    >
      Virginia
    </h3>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Abingdon </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3230"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3230"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Bristol </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5266"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5266"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Christiansburg </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4018"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup menu</a
          >
        </div>
         <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/4018"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Danville </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5269"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/5269"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Lynchburg </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3936"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3936"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
    <div class="sub-menu-details mb-6">
      <div class="items-center">
        <div class="sub_menu_more_details_btn">
          <div
            class="group mb-1 flex w-full items-center text-base font-extrabold leading-5 text-primary-100"
          >
            <span class="w-4/5"> RISE Dispensary Roanoke </span>
          </div>
        </div>
      </div>
      <div class="flex justify-between gap-x-3">
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3416"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Pickup Menu</a
          >
        </div>
        <div class="single-menu-button list_dispensaries_menu_btn w-full">
          <a
            href="https://www.iheartjane.com/embed/stores/3416"
            class="menu-detail-btn my-1 mx-0 inline-block w-full rounded border-[1px] border-solid border-primary-100 bg-[#fff] py-3 px-2 text-center text-sm font-bold uppercase leading-[18px] tracking-[.15px] text-primary-100 hover:cursor-pointer hover:bg-primary-100 hover:text-[#fff] sm:whitespace-nowrap md:whitespace-normal"
            >Delivery Menu</a
          >
        </div>
      </div>
    </div>
  </section>
</div>
`;

export default StateHtml;
